/**
 * LocalStorage Service
 *
 * Auth functions are deprecated - import from @/features/auth/services instead.
 * Sidebar functions remain here as they're shared concerns.
 */

// Re-export auth functions for backward compatibility
// @deprecated Import from @/features/auth/services instead
export {
  getAuthDeviceId,
  generateNewDeviceId,
} from "@/features/auth/services/localStorage.service";

// =============================================================================
// SIDEBAR STATE (Shared concern, stays here)
// =============================================================================

export const saveSidebarState = (isCollapsed: boolean): void => {
  localStorage.setItem("sidebarCollapsed", JSON.stringify(isCollapsed));
};

export const getSidebarState = (): boolean | null => {
  const savedState = localStorage.getItem("sidebarCollapsed");
  if (savedState === null) return null;
  try {
    return JSON.parse(savedState);
  }
  catch {
    return null;
  }
};
